import { render, staticRenderFns } from "./VesselMachines.vue?vue&type=template&id=2e38e159&scoped=true&"
import script from "./VesselMachines.vue?vue&type=script&lang=js&"
export * from "./VesselMachines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38e159",
  null
  
)

export default component.exports